import { render } from "./ServiceTypeButtonFilter.vue?vue&type=template&id=33dc0506"
import script from "./ServiceTypeButtonFilter.vue?vue&type=script&lang=js"
export * from "./ServiceTypeButtonFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__